// extracted by mini-css-extract-plugin
export default {"container":"dcc_checkout-container","headerContainer":"dcc_checkout-headerContainer"};